<template>
  <section class="table container">
    <div class="table__ContentWrapper">
      <div v-for="row in data.rows" class="table__Row">
        <div v-text="row.column1" />
        <div v-text="row.column2" />
      </div>
    </div>
  </section>
</template>

<script setup>
  defineProps({ data: {}});
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_table.scss');
</style>